import { Component, OnInit, Input } from '@angular/core';
import { Colors } from '../../../../models/enums/colors.enum';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss']
})
export class ServiceComponent implements OnInit {

  @Input() value: string = "Value";
  @Input() status: boolean = true;
  @Input() statusColor: string = Colors.lightBlue;
  @Input() systemId: string;
  @Input() subSystemId: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/table-column/services-row/service/service.component.ts